import {createTypes} from 'redux-action-creator'

export default createTypes(
  [
    'SET_STEP',
    'NEXT_STEP_FROM_NONE',
    'NEXT_STEP_FROM_START',
    'NEXT_STEP_FROM_RESERVATION',
    'NEXT_STEP_FROM_DELIVERY',
    'NEXT_STEP_FROM_PICKUP',
    'NEXT_STEP_FROM_ADDRESS',
    'NEXT_STEP_FROM_PAYMENT',
    'NEXT_STEP_FROM_REVIEW',
  ],
  'RENT/ORCHESTRATOR',
)



// WEBPACK FOOTER //
// ./src/sections/rent/types/orchestrator.js